(function () {
  // Single source of truth for auth screen id (injected in theme.liquid)
  // window.__TAPCART_AUTH = { customId: "<injected>" }
  function isInApp() {
    return window.__isTapcart === true ||
      !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.Tapcart) ||
      typeof window.CustomBlockJavascriptInterface !== 'undefined' ||
      !!(window.Tapcart && window.Tapcart.variables && window.Tapcart.variables.device);
  }
  function tryNativeLogin() {
    if (!isInApp()) return false;
    var id = window.__TAPCART_AUTH && window.__TAPCART_AUTH.customId;
    if (!id) return false;
    var destination = { type: 'custom_screen', url: '/custom/' + id };
    try {
      // Optional native paths — only if present
      if (window.Tapcart && typeof window.Tapcart.openScreen === 'function') {
        window.Tapcart.openScreen({ destination: destination });
        return true;
      }
      if (window.Tapcart && typeof window.Tapcart.navigate === 'function') {
        window.Tapcart.navigate({ destination: destination });
        return true;
      }
    } catch (e) { /* swallow & fallback */ }
    return false; // triggers web fallback
  }
  window.tapcartAuth = { isInApp: isInApp, login: tryNativeLogin };
})();
